<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="流程实例ID">
              <a-input placeholder="流程实例ID" v-model="queryParam.id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="流程发起人">
              <a-input placeholder="流程发起人" v-model="queryParam.startUser"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <div>
      

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="submit(record)">提交</a>
          <a-divider type="vertical"/>
          <a v-if="record.flowStatus!='hangUp' && record.flowStatus!='end'" @click="lcsjglGq(record)">挂起</a>
          <a-divider v-if="record.flowStatus!='hangUp' && record.flowStatus!='end'" type="vertical"/>
          <a v-if="record.flowStatus=='hangUp'" @click="lcsjglFh(record)">恢复</a>
          <a-divider v-if="record.flowStatus=='hangUp'" type="vertical"/>
          <a v-if="record.flowStatus!='hangUp' && record.flowStatus!='end'" @click="lcsjglGb(record)">关闭</a>
          <a-divider v-if="record.flowStatus!='hangUp' && record.flowStatus!='end'" type="vertical"/>
          <a v-if="record.flowStatus!='hangUp' && record.flowStatus!='end'" @click="openDetailWp(record)">委派</a>
          <a-divider v-if="record.flowStatus!='hangUp' && record.flowStatus!='end'" type="vertical"/>
          <a @click="openDetailTz(record)">跳转</a>
          <a-divider type="vertical"/>
          <a @click="handleView(record)">详情</a>

          <!-- <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handlePerssion(record.id)">授权</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
        
      </a-table>
    </div>

    <lcsjgModal ref="lcsjgView"></lcsjgModal>

    <lcsjgTz ref="lcsjgTz" @updataList="updataList"></lcsjgTz>
    <lcsjgWp ref="lcsjgWp" @updataList="updataList"></lcsjgWp>

  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { httpAction } from '@/api/manage'
// import LcsjglModal from './modules/LcsjglModal'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import XDictSelectTag from '@/components/xdhm/XDictSelectTag'
import lcsjgModal from './modules/LcsjgModal'
import lcsjgTz from './modules/LcsjgTz'
import lcsjgWp from './modules/LcsjgWp'


export default {
  name: 'lcsjgList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
      lcsjgModal,
      lcsjgTz,
      lcsjgWp,
      XDictSelectTag
    },
  data() {
    return {
      description: '流程实例管理',
      // 表头
      columns: [
          {
            title: '流程ID',
            dataIndex: 'flowType',
            align:"center",
            sorter: true
          },
          {
            title: '流程名称',
            align:"left",
            dataIndex: 'flowTypeName',
            sorter: true
          },
          {
            title: '流程实例ID',
            dataIndex: 'id',
            align:"center",
            sorter: true
          },
          {
            title: '客户姓名',
            dataIndex: 'buzUser',
            align:"center",
            sorter: true
          },
          {
            title: '发起人',
            dataIndex: 'startUser',
            align:"center",
            sorter: true
          },
          {
            title: '办理角色',
            dataIndex: 'currRole',
            align:"center",
          },
          {
            title: '办理人',
            dataIndex: 'currUser',
            align:"center",
            sorter: true
          },
          {
            title: '开始时间',
            dataIndex: 'startDate',
            align:"center",
            sorter: true
          },
          {
            title: '最后操作时间',
            dataIndex: 'updateDate',
            align: "center",
            sorter: true
          },
          // {
          //   title: '耗时',
          //   dataIndex: 'startDate',
          //   align:"center",
          //   sorter: true
          // },
          {
            title: '状态',
            dataIndex: 'flowStatus',
            align:"center",
            sorter: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            // fixed:"right",
            width: 147,
            scopedSlots: { customRender: 'action' },
          },
      ],
      modal: {
        title: '    审批进度',
        fullscreen: true,
        switchFullscreen: true,
      },
      url: {
        list: '/okflow/flow-data/list/page',
        submit: '/okflow/flow-data/submit',
        hangup: '/okflow/flow-data/hangup',
        recovery: '/okflow/flow-data/recovery',
        close: '/okflow/flow-data/close',
        importExcelUrl: '/okflow/flow-data/',
      },
      dictOptions: {},
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    // 提交
    submit(record) {
      httpAction(this.url.submit+"?flowId="+record.id,null,'post').then((res)=>{
        this.$message.warning(res.message);
        this.loadData();
      })
    },
    //详情
    handleView(record) {
      record.viewType = '01';
      this.$refs.lcsjgView.doView(record)
      //  this.$refs.lcsjgView.view(record);
      //  this.$refs.lcsjgView.title = "详情";
    },
    //挂起
    lcsjglGq(record) {
      httpAction(this.url.hangup+"?flowId="+record.id,null,'post').then((res)=>{
        this.$message.warning(res.message);
        this.loadData();
      })
    },
    //回复
    lcsjglFh(record) {
      httpAction(this.url.recovery+"?flowId="+record.id,null,'post').then((res)=>{
        this.$message.warning(res.message);
        this.loadData();
      })
    },
    //关闭
    lcsjglGb(record) {
      httpAction(this.url.close+"?flowId="+record.id,null,'post').then((res)=>{
        this.$message.warning(res.message);
        this.loadData();
      })
    },
    //委派
    openDetailWp(record) {  
      // httpAction(this.url.lcView+"?flowId="+record.id,null,'get').then((res)=>{
      //   this.flowLogList = res;
      // })
      this.$refs.lcsjgWp.toWp(record)
    },
    //跳转
    openDetailTz(record) {
      this.$refs.lcsjgTz.toTz(record)
    },

    //重新刷新数据
    updataList(){

     this.loadData();
    }
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>